const statusCodes = {};
const GoogleSignIn = () => {};
export default {statusCodes, GoogleSignIn};
